import React, { useMemo } from 'react'

import Header from '../../common/components/Header'
import TextInput from '../../common/components/TextInput'
import TextArea from '../../common/components/TextArea'
import Button, { BUTTON_STYLES } from '../../common/components/Button'

import { useEditSigEvent } from '../hooks'

import styles from './Form.module.css'

const EditEventForm = () => {
  const [
    { subject, description, address, latitude, longitude, error },
    { edit, searchAddress, zoomTo, setSubject, setDescription, setAddress },
  ] = useEditSigEvent()

  const addressSearchButton = useMemo(
    () => ({
      icon: 'fa fa-search',
      onClick: searchAddress,
    }),
    [searchAddress]
  )

  return (
    <div className={styles.container}>
      <Header>Edit Significant Event</Header>
      <div>
        <TextInput label="Subject" value={subject} onChange={setSubject} />
        <TextInput
          label="Address"
          value={address}
          onChange={setAddress}
          button={addressSearchButton}
        />
        <TextInput
          label="Latitude"
          value={latitude}
          disabled={true}
          className={styles.latLng}
        />
        <TextInput
          label="Longitude"
          value={longitude}
          disabled={true}
          className={styles.latLng}
        />
        <Button
          text={<i className="fas fa-crosshairs fa-2x"></i>}
          style={BUTTON_STYLES.NO_BORDER}
          onClick={zoomTo}
        />
        <TextArea
          label="Description"
          placeholder="Enter description of event."
          rows={10}
          value={description}
          onChange={setDescription}
        />
        {error && <div className={styles.errorMessage}>{error}</div>}
        <Button text="Save" style={BUTTON_STYLES.PRIMARY} onClick={edit} />
      </div>
    </div>
  )
}

export default EditEventForm
